import React from 'react';

import { flagStyles } from '../settings';

const SvgER = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1560px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgER;
